var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCecotec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 37 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3eb1c8",
    fillRule: "nonzero",
    transform: "translate(-113.278 -.143216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.266 29.341c3.471-.019 6.935-1.338 9.563-3.955 2.615-2.508 4.066-5.998 4-9.62.066-3.623-1.385-7.113-4-9.62-.712-.706-1.492-1.339-2.33-1.89-.69-.43-1.111-1.187-1.111-2 0-1.293 1.064-2.356 2.356-2.356.44 0 .872.123 1.245.356 0 0 2.219 1.566 3.16 2.5 3.485 3.393 5.421 8.076 5.35 12.94.072 4.857-1.865 9.535-5.35 12.92-3.56 3.543-8.26 5.315-12.96 5.315h-.01c-4.7 0-9.4-1.772-12.96-5.315-3.485-3.385-5.422-8.063-5.35-12.92-.071-4.864 1.865-9.547 5.35-12.94.941-.934 3.16-2.5 3.16-2.5.374-.233.805-.356 1.245-.356 1.292 0 2.356 1.063 2.356 2.356 0 .813-.421 1.57-1.111 2-.838.551-1.618 1.184-2.33 1.89-2.615 2.507-4.066 5.997-4 9.62-.066 3.622 1.385 7.112 4 9.62 2.648 2.638 6.146 3.956 9.645 3.955z",
    transform: "translate(119.411 9.00436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.58 17.81h.03c1.278 0 2.33-1.052 2.33-2.33v-13.14c-.08-1.229-1.114-2.197-2.345-2.197s-2.265.968-2.345 2.197v13.13.01c0 1.278 1.052 2.33 2.33 2.33z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCecotec);
export default __webpack_public_path__ + "static/media/cecotec.f9997004.svg";
export { ForwardRef as ReactComponent };